import React from 'react';

// Botón del lenguaje visual nuevo (píldora). primary = tinta (alto contraste, invierte con el tema): solo la acción
// principal de la pantalla. quiet = secundaria, ghost = terciaria, danger = borrar o apagar.
const VARIANTS = {
  primary: 'bg-fg text-ink hover:bg-fg/85 active:scale-[0.98] disabled:bg-raised disabled:text-fg-faint',
  quiet:   'bg-raised text-fg ring-1 ring-inset ring-line hover:ring-fg/20 active:scale-[0.98] disabled:text-fg-faint',
  ghost:   'bg-transparent text-fg-dim hover:text-fg hover:bg-raised disabled:text-fg-faint',
  danger:  'bg-transparent text-signal ring-1 ring-inset ring-signal/40 hover:bg-signal-soft disabled:opacity-50',
};
const SIZES = { sm: 'h-8 px-3.5 text-[13px]', md: 'h-10 px-5 text-[14px]', lg: 'h-12 px-6 text-[15px]' };

export default function Btn({ variant = 'quiet', size = 'md', loading = false, disabled, icon: Icon, children, className = '', ...rest }) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition duration-150 disabled:cursor-not-allowed
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-live focus-visible:ring-offset-2 focus-visible:ring-offset-ink
        ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {loading ? <span className="h-3.5 w-3.5 rounded-full border-2 border-current border-r-transparent animate-spin" aria-hidden /> : Icon ? <Icon aria-hidden className="h-3.5 w-3.5" /> : null}
      {children}
    </button>
  );
}
